/**
 * Legacy OrdersApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.ordersApi`) keep resolving.
 *
 * The actual `OrdersApiService` is now exposed indirectly: the Angular 18
 * `ApiService` facade (registered as the downgraded `'ApiService'` in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts) exposes
 * `apiService.orders` as an `inject(OrdersApiService)` Angular 18 class.
 * The actual implementation lives at
 *   apps/b2b-frontend/app/core/api/orders/orders-api.service.ts
 *
 * Do NOT register `.service('OrdersApiService', ...)` here — nothing
 * consumes it directly anymore.
 */
angular.module("acme.common.service.ordersApi", [
  "acme.common.factory.QueryStringBuilder",
  "acme.common.factory.apiVersion",
]);
